<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 9786 9786"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <circle class="fil0" cx="4893" cy="4893" r="4893"/>
     <g id="_808039056">
     <path class="fil1"
           d="M4265 6414c-26,-88 -26,-356 -2,-464l1260 -7 6 473c-107,35 -873,13 -1101,15 -68,0 -108,9 -163,-17zm95 -1404c-70,-330 156,-597 425,-651 339,-67 589,168 642,425 144,704 -921,919 -1067,226zm-1767 136c118,1181 1199,2189 2544,2048 1208,-127 2176,-1187 2058,-2548 -103,-1181 -1209,-2198 -2552,-2054 -739,80 -1334,516 -1637,957 -204,299 -267,471 -363,803 -65,224 -73,560 -50,794z"/>
       <path class="fil1"
             d="M7434 3956c92,232 162,658 162,937 -1,405 -80,591 -163,937 527,-3 493,-53 640,132l206 261 750 2 -3 -2667 -752 4c-395,490 -145,389 -840,394z"/>
       <path class="fil1"
             d="M1519 6207c385,-490 182,-365 833,-379 -244,-892 -204,-1029 2,-1871 -609,-20 -446,113 -741,-262 -132,-168 -94,-137 -365,-137 -157,0 -314,1 -471,0 -43,186 -9,1064 -10,1316 0,448 0,896 1,1343l751 -10z"/>
       <path class="fil1"
             d="M1519 6207l-751 10c-1,-447 -1,-895 -1,-1343 1,-252 -33,-1130 10,-1316 -37,27 -38,-60 -29,152 30,673 -48,1986 5,2511 112,38 558,14 708,14 84,-9 34,-3 58,-28z"/>
       <path class="fil1"
             d="M4265 6414l8 -453 1236 0 2 451 -1246 2zm0 0c55,26 95,17 163,17 228,-2 994,20 1101,-15l-6 -473 -1260 7c-24,108 -24,376 2,464z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'WaterPump',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
